import React from 'react';
import PropTypes from 'prop-types';
import { Button, Dropdown, Icon } from 'semantic-ui-react';

const propTypes = {
  view: PropTypes.string.isRequired,
  sortBy: PropTypes.string.isRequired,
  setSortBy: PropTypes.func.isRequired,
};

const options = [
  {
    key: 'v',
    value: 'views',
    text: 'Popularity',
    description: <Icon name="users" />,
  },
  {
    key: 'l',
    value: 'location',
    text: 'Location',
    description: <Icon name="map outline" />,
  },
  {
    key: 'au',
    value: 'alphaUp',
    text: 'Title',
    description: <Icon name="sort alphabet ascending" />,
  },
  {
    key: 'ad',
    value: 'alphaDown',
    text: 'Title',
    description: <Icon name="sort alphabet descending" />,
  },
];

const RightNav = ({ view, sortBy, setSortBy }) => (
  <div id="right" >
    {(view === 'home') ? (
      <Button
        style={{ margin: 'auto' }}
        basic
        onClick={() => { window.open('http://www.bu.edu/globalprograms/hub/share-a-resource/', '_blank'); }}
      >
        Suggest Resource
      </Button>
    ) : (
      <Dropdown
        selection
        labeled
        value={sortBy}
        header="Sort By"
        options={options}
        onChange={(e, { value }) => {
          setSortBy(value);
        }}
      />
    )}
  </div>
);

RightNav.propTypes = propTypes;

export default RightNav;



// WEBPACK FOOTER //
// ./src/components/RightNav.jsx